export default "<ct-table [tableGridData]=\"tableData\" (editAction)=\"edit($event)\" #gridTable ></ct-table>\n\n\n\n"